import { tickToPrice } from 'elephantswapv3-sdk'
import { Token } from 'elephantswapv3-sdk-core'
import { TickProcessed } from 'hooks/usePoolTickData'
import JSBI from 'jsbi'

import { Ticks } from '../graphql/thegraph/AllV3TicksQuery'

// Computes the numSurroundingTicks above or below the active tick.
export default function computeSurroundingTicks(
  token0: Token,
  token1: Token,
  activeTickProcessed: TickProcessed,
  sortedTickData: Ticks,
  pivot: number,
  ascending: boolean
): TickProcessed[] {
  let activeLiquidity = activeTickProcessed.liquidityActive
  let processedTicks: TickProcessed[] = []

  if (ascending) {
    // Crossing an initialized tick upwards applies its liquidityNet before the
    // following interval begins.
    for (let i = pivot + 1; i < sortedTickData.length; i++) {
      const tick = Number(sortedTickData[i].tick)
      const liquidityNet = JSBI.BigInt(sortedTickData[i].liquidityNet)
      activeLiquidity = JSBI.add(activeLiquidity, liquidityNet)
      processedTicks.push({
        liquidityActive: activeLiquidity,
        tick,
        liquidityNet,
        price0: tickToPrice(token0, token1, tick).toSignificant(18),
      })
    }
  } else {
    let startIndex = pivot

    // Pool liquidity is already on the upper side of an initialized active
    // tick. Remove that tick's net amount before walking into lower intervals.
    if (Number(sortedTickData[pivot].tick) === activeTickProcessed.tick) {
      activeLiquidity = JSBI.subtract(activeLiquidity, JSBI.BigInt(sortedTickData[pivot].liquidityNet))
      startIndex -= 1
    }

    for (let i = startIndex; i >= 0; i--) {
      const tick = Number(sortedTickData[i].tick)
      const liquidityNet = JSBI.BigInt(sortedTickData[i].liquidityNet)
      processedTicks.push({
        liquidityActive: activeLiquidity,
        tick,
        liquidityNet,
        price0: tickToPrice(token0, token1, tick).toSignificant(18),
      })
      activeLiquidity = JSBI.subtract(activeLiquidity, liquidityNet)
    }
  }

  if (!ascending) {
    processedTicks = processedTicks.reverse()
  }

  return processedTicks
}
